import { useStyles } from '@signavio/ui'
import { Body, Box, Caption } from '@signavio/ui/core'

import { userUtils } from '../../utils'
import Avatar from './Avatar'
import { UserType } from '../../../types'
import { ThemeT } from '@signavio/effektif-commons'

type UserTileProps = {
  user: UserType

  small?: boolean
  disabled?: boolean
  circular?: boolean
  transparent?: boolean

  toolbar?: React.ReactNode
}

function UserTile({
  user,
  small,
  disabled,
  circular,
  toolbar,
  transparent,
}: UserTileProps) {
  const styles = useStyles(
    defaultStyles,
    {},
    { '&transparent': Boolean(transparent) }
  )

  return (
    <div {...styles} aria-label={userUtils.name(user)}>
      <Avatar
        circular={circular}
        disabled={disabled}
        small={small}
        user={user}
      />

      <Box
        style={styles('content')}
        marginLeft={circular ? 'xxsmall' : 'small'}
      >
        <Body ellipsis>{userUtils.name(user)}</Body>

        {userUtils.name(user) !== user.emailAddress && !small && (
          <Caption ellipsis style={styles('email')}>
            {user.emailAddress}
          </Caption>
        )}
      </Box>

      {toolbar}
    </div>
  )
}

const defaultStyles = ({ color }: ThemeT) => ({
  display: 'flex',

  alignItems: 'center',

  backgroundColor: color.background,

  content: {
    flexGrow: 1,
  },

  email: {
    color: color.text.disabled,

    lineHeight: '14px',
  },

  '&transparent': {
    backgroundColor: null,
  },
})

export default UserTile
